import React, { useEffect, useState } from "react";
import BasicInput from "../Basic/BasicInput";

function TcIndexValue({ tcIndex, countIndex, changeFieldsMultiple, required = false, setHasErrors }) {
    const [stateIndex, setStateIndex] = useState(tcIndex);

    useEffect(() => {
        if (required) {
            if (!stateIndex) {
                setHasErrors('tcIndex', true)
            } else {
                setHasErrors('tcIndex', false)
            };
        }
    }, [stateIndex]);
    
    const changeTcIndex = () => {
        tcIndex !== stateIndex && changeFieldsMultiple([
            {
                index: countIndex,
                field: 'tcIndex',
                value: stateIndex,
            }
        ]);
    }
    
    return (
        <BasicInput 
            name='tcIndex'
            value={stateIndex}
            onChange={(e) => setStateIndex(e.target.value)}
            floatingLabelStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            type='number'
            onBlur={changeTcIndex}
        />
    );
}

export default React.memo(TcIndexValue);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/TcIndexValue.jsx